import { em, rem } from 'polished'
import styled from 'styled-components'

export const ImporterPreviewTableStyled = styled.div`
  font-size: ${rem(16)};

  width: 100%;

  position: relative;

  th {
    white-space: nowrap;
    cursor: pointer;
    padding: 0;
  }

  th:last-child {
    padding: 0;
  }

  .mapped-column {
    display: inline-block;
    width: 100%;
    padding: ${em(16)};
  }

  > .importer-preview-table {
    width: 100%;
    overflow-x: scroll;
  }

  > .importer-preview-overlay {
    font-size: ${em(11)};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    color: ${(props) => props.theme.colors.primary};

    display: flex;

    justify-content: center;
    align-items: center;

    position: absolute;
    bottom: ${rem(10)};
    left: ${rem(1)};
    right: ${rem(1)};

    height: ${rem(50)};

    overflow: hidden;

    > span {
      position: relative;
      z-index: 2;
    }

    ::before {
      content: '';
      display: block;

      position: absolute;
      height: ${rem(1)};
      left: 0;
      right: 0;
      bottom: 0;

      box-shadow: 0 0 25px 25px #fff;
    }
  }
`
